import TransitionEffect from "./TransitionEffect";

export default TransitionEffect;
